// 細かい調整をしているので、あまり定数として汎用性がない
export const LARGE_IMAGE_SIZE = 360;
export const MEDIUM_IMAGE_SIZE = 280;
export const SMALL_IMAGE_SIZE = 240;
export const X_SMALL_IMAGE_SIZE = 176;
